import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { 
  FaMapMarkerAlt, FaMapPin, FaPhoneAlt, FaChevronRight, 
  FaClock, FaBus, FaArrowRight, FaCheckCircle 
} from "react-icons/fa";
import { baseurl } from "../../baseurl";
import "../../asset/css/bus-bpdp-new.css";

const BusBPDP = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [boardingPoints, setBoardingPoints] = useState([]);
  const [droppingPoints, setDroppingPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("boarding"); // 'boarding' or 'dropping'

  const [selectedBP, setSelectedBP] = useState(null);
  const [selectedDP, setSelectedDP] = useState(null);

  useEffect(() => {
    const fetchBPDP = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseurl}/getBpdpDetails/${id}`);
        const data = response.data.data;
        setBoardingPoints(Array.isArray(data.boardingPoints) ? data.boardingPoints : [data.boardingPoints]);
        setDroppingPoints(Array.isArray(data.droppingPoints) ? data.droppingPoints : [data.droppingPoints]);
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchBPDP();
  }, [id]);

  const handleProceed = () => {
    if (!selectedBP || !selectedDP) return;
    navigate(`/bus-seats/${id}`, { state: { selectedBP, selectedDP } });
  };

  if (loading) return (
    <div className="loader-wrapper">
      <div className="bus-loader"></div>
      <p>Finding the best route for you...</p>
    </div>
  );

  return (
    <div className="bpdp-modern-layout">
      {/* Step Progress Bar */}
      <div className="progress-header shadow-sm">
        <div className="container">
          <div className="steps-wrapper">
            <div className="step active"><span>1</span> Points</div>
            <div className="step-line"></div>
            <div className="step"><span>2</span> Seats</div>
            <div className="step-line"></div>
            <div className="step"><span>3</span> Payment</div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <div className="row g-4">
          <div className="col-lg-8">
            {/* Selection Tabs */}
            <div className="selection-card shadow-sm border-0">
              <div className="tab-header">
                <button 
                  className={`tab-btn ${activeTab === 'boarding' ? 'active' : ''}`}
                  onClick={() => setActiveTab('boarding')}
                >
                  <FaMapMarkerAlt className="me-2" /> Boarding Points
                  {selectedBP && <FaCheckCircle className="ms-auto text-success" />}
                </button>
                <button 
                  className={`tab-btn ${activeTab === 'dropping' ? 'active' : ''}`}
                  onClick={() => setActiveTab('dropping')}
                >
                  <FaMapPin className="me-2" /> Dropping Points
                  {selectedDP && <FaCheckCircle className="ms-auto text-success" />}
                </button>
              </div>

              <div className="points-list-wrapper">
                {(activeTab === "boarding" ? boardingPoints : droppingPoints).map((point) => (
                  <div 
                    key={point.id} 
                    className={`point-item ${
                      (activeTab === 'boarding' ? selectedBP?.id : selectedDP?.id) === point.id ? 'selected' : ''
                    }`}
                    onClick={() => {
                      if (activeTab === 'boarding') {
                        setSelectedBP(point);
                        setActiveTab('dropping'); // Auto-switch to dropping for better UX
                      } else {
                        setSelectedDP(point);
                      }
                    }}
                  >
                    <div className="point-radio"></div>
                    <div className="point-content">
                      <div className="d-flex justify-content-between">
                        <h6 className="point-name">{point.name}</h6>
                        <span className="point-time"><FaClock className="me-1" /> {point.time || '--:--'}</span>
                      </div>
                      <p className="point-address">{point.address}</p>
                      {point.contactnumber && (
                        <span className="point-phone"><FaPhoneAlt size={10} /> {point.contactnumber}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            {/* Summary Sticky Card */}
            <div className="summary-card sticky-top shadow border-0">
              <h5 className="summary-title"><FaBus className="me-2" /> Route Summary</h5>
              <div className="route-viz">
                <div className="viz-point">
                  <div className="viz-dot boarding"></div>
                  <div className="viz-info">
                    <small>Boarding Point</small>
                    <p>{selectedBP ? selectedBP.name : 'Select Point'}</p>
                  </div>
                </div>
                <div className="viz-line"></div>
                <div className="viz-point">
                  <div className="viz-dot dropping"></div>
                  <div className="viz-info">
                    <small>Dropping Point</small>
                    <p>{selectedDP ? selectedDP.name : 'Select Point'}</p>
                  </div>
                </div>
              </div>

              <button 
                className="btn-proceed-modern mt-4"
                disabled={!selectedBP || !selectedDP}
                onClick={handleProceed}
              >
                PROCEED TO SEATS <FaArrowRight className="ms-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusBPDP;